import { render, staticRenderFns } from "./LunchMenuCategoryListing.vue?vue&type=template&id=009684a0&"
import script from "./LunchMenuCategoryListing.vue?vue&type=script&lang=js&"
export * from "./LunchMenuCategoryListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports